import React from "react";
import { Field } from "formik";
import { Fields } from "uicomponents";
import useTranslation from "../../../hooks/useTranslation";

const Form = ({ isSubmitting, isUpdate, values }) => {
  const { tr } = useTranslation();

  return (
    <div>
      <Field
        component={Fields.InputS1}
        name="name"
        type="text"
        placeholder={tr("Введите название")}
        label={tr("Название")}
        isRequired={true}
        size={"small"}
      />

      <Field
        component={Fields.CheckboxS1}
        name="status"
        checked={values.status}
        label={tr("Статус")}
        position={"left"}
      />

      <div className="d-flex justify-content-end">
        <button
          type="submit"
          className={`d-btn d-btn-primary ${isSubmitting ? "--loading" : ""}`}
          disabled={isSubmitting}
        >
          {isUpdate ? tr("Сохранить") : tr("Добавить")}
        </button>
      </div>
    </div>
  );
};

export default Form;
